<form id="info-adicional" class="row form-aditional-styles first-container-identification-xs m-t-34 m-t-xs-40 m-b-29 form-width-size" [formGroup]="form" (ngSubmit)="saveStepTwo($event)" autocomplete="off">
  <div class="col-12 m-b-36 d-flex justify-content-between align-items-start">
    <div class="container-return-style align-self-start">
      <img class="img-return-blue" [src]="url_img.return_blue" alt="" (click)="previous('I')">
    </div>
    <app-header-steps></app-header-steps>
  </div>
  <div class="col-12 m-b-20">
    <div class="">
      <div class="d-block w-100">
        <p class=" heading-b-m-24 text-start line-height-20 text-start m-b-20">
          Completa tu información
        </p>
      </div>
    </div>
  </div>

  <div class="col-12 m-b-40">
    <div class="container-bottom-dynamic" [ngClass]="{'input-error-style': (radioOccupation.invalid && radioOccupation.touched) || ((selectOccupation.invalid && selectOccupation.touched)) }">
      <p class=" paragraph-b-r-16 text-start line-height-20 m-b-16">
        ¿A qué te dedicas?
      </p>
      <div class="form-check radio-style-form radio-repet-bottom" *ngFor="let item of occupationsRadio">
        <label class="form-check-label radio-content " for="occupation_{{item.ocupacion}}">{{item.xlbez}}
          <input class="form-check-input" type="radio" formControlName="radio_occupation" id="occupation_{{item.ocupacion}}" [value]="item.ocupacion" (change)="setRequiredOptions()">
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="form-check form-check-inline radio-style-form m-b-5">
        <label class="form-check-label radio-content " for="occupation">
          <select class="paragraph-b-r-16 select-field-style width-240" formControlName="select_occupation" (change)="setAnotherOption()">
            <option value="">Elige otro</option>
            <option *ngFor="let option of occupationsSelect" value="{{option.ocupacion}}">{{option.xkbez | titlecase}}</option>
          </select>

          <!--?Nuevo select para verlo regresar a d-block la clase d-none-->
          <div ngbDropdown class="button-dropdown-style d-none w-240">
            <div class="button-generic-style button-outline button-drop-style text-start width-240 height-40 d-flex justify-content-between align-items-center p-y-11" id="dropdownBasic1" ngbDropdownToggle> 
              <span>Elige otro</span> <img class="img-arrowdown-blue" [src]="url_img.arrowdown_blue" alt="">
            </div>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="drop-container-style">                
              <button ngbDropdownItem>Another Action</button>
              <button ngbDropdownItem>Something else is here</button>
            </div>
          </div>
          
          <input class="form-check-input" type="radio" formControlName="radio_occupation" id="occupation" value="0" (change)="setRequiredOptions()">
          <span class="checkmark top-10"></span>
        </label>
      </div>
      <p class="text-error-style d-flex align-items-center" *ngIf=" (radioOccupation.invalid && radioOccupation.touched) || (selectOccupation.invalid && selectOccupation.touched)">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="">Elige una opción para continuar
      </p>
    </div>
  </div>
  <!--!Inicia - Informacion en caso de ser empleado-->
  <div class="w-100" [hidden]="showInputOccupation">
    <div class="  col-12 m-b-20">
      <div [ngClass]="{'input-error-style': proffesionInput.invalid && proffesionInput.touched }">
        <label for="" class="paragraph-b-r-16 mb-2">
          ¿Cuál es tu profesión?
        </label>
        <input  class="form-control input-field-style" 
                placeholder="" 
                type="text" 
                oninput="this.value = this.value.toUpperCase()"
                formControlName="cx_profesion" 
                only-letters
                maxlength="25"
                autocomplete="off">
        <p class="text-error-style d-flex align-items-center"  *ngIf="proffesionInput.invalid && proffesionInput.touched" >
          <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
          </p>
      </div>
    </div>

    <div class="  col-12 m-b-20">
      <div [ngClass]="{'input-error-style': companyInput.invalid && companyInput.touched }">
        <label for="" class="paragraph-b-r-16 mb-2">
          Nombre de la empresa donde trabajas
        </label>
        <input  class="form-control input-field-style" 
                placeholder="" 
                type="text" 
                oninput="this.value = this.value.toUpperCase()"
                formControlName="nombreEmpresa" 
                only-letters
                maxlength="25"
                autocomplete="off">
        <p class="text-error-style d-flex align-items-center" *ngIf="companyInput.invalid && companyInput.touched">
          <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
        </p>
      </div>
    </div>

    <div class="  col-12 m-b-40">
      <div [ngClass]="{'input-error-style': positionInput.invalid && positionInput.touched }">
        <label for="" class="paragraph-b-r-16 mb-2">
          ¿Cuál es tu puesto en esa empresa?
        </label>
        <input  class="form-control input-field-style" 
                placeholder="" 
                type="text" 
                oninput="this.value = this.value.toUpperCase()"
                formControlName="puesto" 
                only-letters
                maxlength="25"
                autocomplete="off">
        <p class="text-error-style d-flex align-items-center" *ngIf="positionInput.invalid && positionInput.touched">
          <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
        </p>
      </div>
    </div>
  </div>
  <!--!Termina - Informacion en caso de ser empleado-->
  
  <div class="col-12 m-b-24 m-b-xs-16">
    <div class="" [ngClass]="{'input-error-style': civilStatusInput.invalid && civilStatusInput.touched }">
      <p class=" paragraph-b-r-16 text-start line-height-20 m-b-16">
        Estado civil
      </p>
      <div class="form-check radio-style-form m-b-16" *ngFor="let item of civilStatusList">
        <label class="form-check-label radio-content " for="cx_edo_civil_{{item.marst}}">{{item.bez20 | titlecase}}
          <input class="form-check-input" type="radio" formControlName="cx_edo_civil"  id="cx_edo_civil_{{item.marst}}" [value]="item.marst" (change)="setValueCivilStatus()">
          <span class="checkmark"></span>
        </label>
      </div>
      <p class="text-error-style d-flex align-items-center" *ngIf="civilStatusInput.invalid && civilStatusInput.touched">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="">Elige una opción para continuar
        </p>
    </div>
  </div>

  <div class="col-12 m-b-20">
    <div [ngClass]="{'input-error-style': showErrorCURP() }">
      <label for="" class="paragraph-b-r-16 mb-1 d-flex align-items-center">
        <span class="m-r-6 d-flex">CURP</span>
        <ng-template #popContent> 
          <span class="popover-text-style paragraph-w-r-16 white-space-nowrap">Para conocer tu CURP visita:<br class="d-block d-md-none">
            <a class="link-generic-white" target="_blank" [href]="url.documents.curp">www.gob.mx/curp</a>
          </span>
            <a class="popover-close-style d-flex" href="javascript:void(0)"> 
              <img class="img-close-white" [src]="url_img.close_white" alt="">
            </a> 
        </ng-template>        
        <!--!En responsive se necesita cambiar el placement a bottom de 767.98 o menos-->
        <a type="button" class="btn-tooltip-style mr-2 d-flex" href="javascript:void(0)" [ngbPopover]="popContent" container="body" popoverClass="custom-popover-style">
          <img class="tooltip-img-question" [src]="url_img.question_blue" alt="">
        </a>
      </label>
      <input  class="form-control input-field-style" 
              placeholder="" 
              type="text" 
              oninput="this.value = this.value.toUpperCase()"
              formControlName="cx_curp" 
              only-curp
              maxlength="18"
              autocomplete="off">
      <p class="text-error-style d-flex align-items-center" *ngIf="showErrorCURP()">
        <img class="circle-error-tomato" [src]="url_img.alert" alt=""> {{msgErrorCURP}}
      </p>
    </div>
  </div>
  <!--!Inicia - Informacion en caso de ser empleado-->
  <div class="col-12 m-b-40">
    <div [ngClass]="{'input-error-style': showErrorRFC() }">
      <label for="" class="paragraph-b-r-16 mb-2">{{tittleRFC}}</label>
      <input  class="form-control input-field-style" 
              placeholder="" 
              type="text" 
              oninput="this.value = this.value.toUpperCase()"
              formControlName="cx_rfc_tin" 
              only-curp
              maxlength="13"
              autocomplete="off">
      <p class="text-error-style d-flex align-items-center" *ngIf="showErrorRFC()">
        <img class="circle-error-tomato" [src]="url_img.alert" alt=""> {{msgErrorRFC}}
      </p>
    </div>
  </div>
  <!--!Termina - Informacion en caso de ser empleado-->

  <div class="col-12 m-b-40">
    <div [ngClass]="{'input-error-style': beneficiarioInput.invalid && beneficiarioInput.touched }">
      <p class=" paragraph-b-r-16 text-start line-height-20 m-b-12">
        ¿Deseas agregar un beneficiario?<br> Debe ser mayor de edad. Es quien recibirá el 100% de los recursos en caso
        de fallecimiento del titular de la cuenta.
      </p>
      <div class="form-check form-check-inline radio-style-form m-b-5">
        <label class="form-check-label radio-content " for="conBeneficiarios1">Sí
          <input class="form-check-input" type="radio" formControlName="conBeneficiarios"  id="conBeneficiarios1" value="SI">
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="form-check form-check-inline radio-style-form m-b-5">
        <label class="form-check-label radio-content " for="conBeneficiarios2">No
          <input class="form-check-input" type="radio" formControlName="conBeneficiarios"  id="conBeneficiarios2" value="NO">
          <span class="checkmark"></span>
        </label>
      </div>
      <p class="text-error-style d-flex align-items-center" *ngIf="beneficiarioInput.invalid && beneficiarioInput.touched">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="">Elige una opción para continuar
      </p>
    </div>
  </div>

  <div class="col-6  text-start">
    <div class="m-b-29">
      <button class="button-generic-style button-outline height-48 w-100" (click)="previous('')">Regresar</button>
    </div>
  </div>
  <div class="col-6  text-end">
    <div class="m-b-29">
      <button class="button-generic-style button-blue height-48 w-100" [disabled]="form.invalid">Continuar</button>
    </div>
  </div>
</form>
